import { useToast } from '@chakra-ui/react';
import { AxiosError } from 'axios';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import {
  ErrorResponseForNormalClientError,
  ErrorResponseForValidate,
} from '@/types/error';

export const useHandleErrors = <TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>,
) => {
  console.info('use-handle-api-error.ts_1');

  const toast = useToast();

  const handleErrors = (error: Error) => {
    console.info('use-handle-api-error.ts_2');

    if (!(error instanceof AxiosError)) {
      console.info('use-handle-api-error.ts_3');
      return;
    }
    console.info('use-handle-api-error.ts_4');
    if (error.response?.status === 500 || !error.response) {
      console.info('use-handle-api-error.ts_5');

      // サーバーエラー
      toast({
        title: 'サーバー内部でエラーが発生しました。',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } else if (error.response?.status === 401) {
      console.info('use-handle-api-error.ts_6');

      // 認証エラー
      return;
    } else if (
      error.response?.status &&
      400 <= error.response?.status &&
      error.response?.status < 500
    ) {
      console.info('use-handle-api-error.ts_7');

      // クライアントエラー
      if (error.response?.status === 422) {
        console.info('use-handle-api-error.ts_8');

        // バリデーションエラー
        const errorResponse = error.response?.data as ErrorResponseForValidate;
        handleApiValidateErrors(errorResponse);
      } else {
        console.info('use-handle-api-error.ts_9');

        // その他のクライアントエラー
        const errorResponse = error.response
          ?.data as ErrorResponseForNormalClientError;
        const message = errorResponse.detail;
        toast({
          title: message || 'エラーが発生しました。',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
    console.info('use-handle-api-error.ts_10');
  };

  const handleApiValidateErrors = (errorResponse: ErrorResponseForValidate) => {
    console.info('use-handle-api-error.ts_11');

    errorResponse.detail.forEach((error) => {
      console.info('use-handle-api-error.ts_12');
      const fieldName = error.loc[error.loc.length - 1]; // locの最後の要素をフィールド名と仮定
      setError(fieldName as Path<TFieldValues>, {
        type: error.type,
        message: error.msg,
      });
    });
  };

  return { handleErrors };
};
